export default __webpack_public_path__ + "static/img/xevant-logo-vertical.024500d1a3c3b3a4c8824803fbea1f2d.png";